/**
 * Created by JIocb on 28.06.2017.
 */
module Factive.Core {
    "use strict"
    import Signal = Factive.Core.Signal.Signal;
    import Armature = dragonBones.Armature;
    import DragonBonesButton = Factive.Game.DragonBonesButton;
    import EventBusConstants = Factive.Core.EventBusConstants;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import Resources = Factive.Game.Resources;
    import ArenaHelper = Arkadium.Game.ArenaHelper;

    export class GameEndPanel extends Panel {

        private _okBtn:DragonBonesButton;
        private _lm:LocalizationManager;
        private _armature: dragonBones.Armature;
        private _message:PIXI.Text;
        private _arenaHelper: ArenaHelper;

        constructor(dc: DependenciesContainer,name:any) {
            "use strict";
            super(dc,name);
            this._lm = this._dc.get("LocalizationManager");
            this._arenaHelper = this._dc.get("ArenaHelper");
        };

        protected build() {
            "use strict";

            this._armature = dragonBones.PixiFactory.factory.buildArmature("Panel_GameEnd");
            this.addChild(<PIXI.DisplayObject>this._armature.display);
            dragonBones.WorldClock.clock.add(this._armature);
            this._armature.animation.play("appear",1);


            this._okBtn = new DragonBonesButton(this._armature.getSlot("PopupRedBtn").childArmature,this._dc);

            this._okBtn.addLabel(this._lm.getText("ok"), 0, 0, <PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: 20* this._assetScale,
                fill: '#FFFFFF',
                align: "center"
            });

            this._okBtn.addPressListener(this.handlePressOk,this);

            this._message = new PIXI.Text(this._lm.getText("your_score")+" "+this._data.score,<PIXI.TextStyle>{
                fontFamily:'Medium',
                fontSize:22* this._assetScale*2,
                fill:'#f9547f',
                align:"center"
            });
            this._message.scale.x = this._message.scale.y = .5;
            this._message.x+=12*this._assetScale;
            this._message.anchor.set(.5,.5);
            this._armature.getSlot("text_container").display = new PIXI.Container();
            this._armature.getSlot("text_container").display.addChild(this._message);

            let ribbonTextureData = Resources.getTextureData("congrad-" + this._arenaHelper.getLocale());
            let ribbonTexture = null;
            if(ribbonTextureData){
                ribbonTexture = new PIXI.Texture(ribbonTextureData.parent.texture, ribbonTextureData.region);
            }
            if(ribbonTexture){
                this._armature.getSlot("congrad").display.texture = ribbonTexture;
            }

            this._calculatePosition();
        };


        private handlePressOk(evt):void
        {
            this._okBtn.removePressListener(this.handlePressOk,this)
            this.sendEvent(EventBusConstants.EVENT_GAME_END_PANEL_PRESS_OK,EventBusConstants.TOPIC_UI, this._data);
        }

        public reset():void
        {
            if(this._armature)
            {
                this._okBtn.removePressListener(this.handlePressOk,this)

                this._okBtn.destroy();

                this._okBtn = null;

                this.removeChild(<PIXI.DisplayObject>this._armature.display);
                dragonBones.WorldClock.clock.remove(this._armature);
                this._armature = null;
            }

            if(this._message) {
                this._message.parent.removeChild(this._message);
            }
            this._message = null;
            super.reset();

            //console.log("RESET BONUS PANEL");
        }
        public destroy():void
        {
            this._okBtn.removePressListener(this.handlePressOk,this)

            this._okBtn.destroy();

            this._okBtn = null;

            this._lm = null;

            this.removeChild(this._message);
            this._message = null;

            super.destroy();

        }

        protected _calculatePosition(){
            if(this._aspectRatio == "landscape")
            {
                this._armature.display.scale.x = this._armature.display.scale.y = 1;
            }
            else if(this._aspectRatio == "portrait")
            {
                this._armature.display.scale.x = this._armature.display.scale.y = 1.3;
            }
        }

        public resize(aspectRatio: string){
            super.resize(aspectRatio);
            if(this._armature == null){
                return;
            }
            this._calculatePosition();
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Panel/GameEndPanel.ts